import { render, staticRenderFns } from "./CheckInfo.vue?vue&type=template&id=3f12f472&scoped=true&"
import script from "./CheckInfo.vue?vue&type=script&lang=ts&"
export * from "./CheckInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CheckInfo.vue?vue&type=style&index=0&id=3f12f472&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f12f472",
  null
  
)

export default component.exports